var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 36,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0799 5.86069C20.0125 5.55972 19.743 5.35907 19.4398 5.35907H11.1315L11.0642 5.42595V3.1185L15.0395 1.78085L16.4881 1.27923C16.825 1.14546 17.0271 0.777608 16.8924 0.443195C16.7576 0.108782 16.387 -0.0918658 16.0501 0.0418994L10.1882 2.04838C9.91874 2.1487 9.7166 2.38279 9.7166 2.68376V5.42595H1.34099C1.03779 5.42595 0.76828 5.6266 0.700902 5.92757L0.0271217 10.4113C-0.0402563 10.6119 0.0271217 10.8126 0.128189 10.9798C0.229256 11.147 0.465079 11.2473 0.667213 11.2473H0.700902L3.87026 35.0987C3.90395 35.4665 4.17346 35.7341 4.54404 35.7341H16.2367C16.6073 35.7341 16.8768 35.4665 16.9105 35.0987L20.0799 11.2473H20.1136C20.3157 11.2473 20.5178 11.147 20.6526 10.9798C20.7873 10.8126 20.821 10.6119 20.7536 10.4113L20.0799 5.86069ZM5.18409 34.3628L2.04842 11.2136H18.7323L15.5966 34.3628H5.18409ZM18.9344 6.7302H1.84631L1.54311 9.87625H19.2376L18.9344 6.7302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkActive);
export default __webpack_public_path__ + "static/media/Drink_Active.7b0afb64b0a5b44c880f94e929b5a949.svg";
export { ForwardRef as ReactComponent };